export const FilterCard = ({ value, label, colorClass, icon: Icon, isActive, onClick, filterType }) => (
  <div 
    className={`stat-card filter-card border-pulse ${isActive ? 'active' : ''}`} 
    data-testid={`filter-card-${filterType}`}
    onClick={onClick}
  >
    <div className="stat-card-header">
      <div>
        <div className={`stat-value ${colorClass}`}>{value}</div>
        <div className="stat-label">{label}</div>
      </div>
      <Icon className={`stat-icon ${colorClass}`} />
    </div>
    {isActive && <div className="filter-active-indicator" />}
  </div>
);
